import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  ViewChild
} from "@angular/core";
import {AbstractVisbosControl} from "../../forms/abstract-visbos-control";
import {FormBuilder, FormControl} from "@angular/forms";
import {GenericModalComponent} from "../../forms/generic-modal/generic-modal.component";

export const CURRENCY_ERRORS = {
  'bruttoRequired': 'Der Preis muss brutto (inkl. MwSt.) angegeben werden!',
  'nettoRequired': 'Der Preis muss netto (ohne MwSt.) angegeben werden!'
};

@Component({
  selector: 'vb-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => CurrencyInputComponent)}]
})
export class CurrencyInputComponent extends AbstractVisbosControl<any, FormControl> implements OnInit, AfterContentChecked {

  @ViewChild('currencyInput') currencyInputEl: ElementRef;

  taxType: 'Netto' | 'Brutto' = 'Netto';

  buttonTitle: string = "Netto/Brutto-Rechner";

  @Input()
  enforce: 'Netto' | 'Brutto' | false = 'Netto';

  @Input()
  tax: number = 0.16;

  @Input()
  id: string = 'currencyInput';

  @Input()
  inputGroupClass: string = 'input-group-sm';

  @ViewChild('taxCalcModal')
  taxCalcModal: GenericModalComponent;


  constructor(fb: FormBuilder, cd: ChangeDetectorRef) {
    super(fb, cd, null);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterContentChecked(): void {
    if (this.enforce == 'Netto' && this.taxType == 'Brutto' && this.control.value != null) {
      this.control.setErrors({
        'bruttoRequired': false,
        'nettoRequired': true
      });
    } else if (this.enforce == 'Brutto' && this.taxType == 'Netto' && this.control.value != null) {
      this.control.setErrors({
        'bruttoRequired': true,
        'nettoRequired': false
      });
    } else {
      this.control.setErrors({
        'bruttoRequired': false,
        'nettoRequired': false
      });
      this.control.updateValueAndValidity();
    }

    let nEl = this.currencyInputEl.nativeElement;
    if (!nEl.validity.valid && nEl.validity.badInput) {
      this.control.setErrors({decimal: true});
    } else {
      this.control.updateValueAndValidity();
    }

  }

  public buildControlContent(values?: any, ...params: any[]): FormControl {
    return this.fb.control(null);
  };

  public setDefaultValues(currency?: number): { [p: string]: any } | any {
    return currency;
  }

  onOpenTaxCalculatorClicked() {
    this.taxCalcModal.show();
  }

  private computedCurrency;

  onTaxComputed(event) {
    this.computedCurrency = event;
  }

  saveComputedCurrency() {
    this.taxType = this.computedCurrency.type;
    this.control.setValue(this.computedCurrency.value.toFixed(2));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/currency-input/currency-input.component.ts